export enum CompanySubscriptionOption {
    ALL = 'all',
    SUBSCRIBED = 'subscribed',
    NOT_SUBSCRIBED = 'not_subscribed',
}
